module.exports = __webpack_public_path__ + "static/media/icon_174.ebbb6fea.svg";